import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { dashboardAPI } from "@/lib/api";
import { installMapLinkInterceptor } from "./lib/utils";
import { installExternalLinkInterceptor } from "./lib/externalLinks";

// Preload dashboard data BEFORE React mounts — fetch starts during JS parse,
// shaving ~200-300ms off the perceived load time for the hero.
// Only on the home route: landing elsewhere and going home later would show that old
// response as live. Dashboard.js also drops it when it is older than PRELOAD_MAX_AGE_MS.
if (window.location.pathname === "/") {
  window.__dashboardPreload = { at: Date.now(), promise: dashboardAPI.getAll().catch(() => null) };
}

// Hide images that fail to load (e.g. a bulletin image the backend hasn't cached yet
// returns 404) instead of showing the browser's broken-image icon. The container keeps
// its placeholder background. Capture phase: image error events don't bubble.
document.addEventListener("error", (e) => {
  const el = e.target;
  if (el && el.tagName === "IMG") el.classList.add("img-failed");
}, true);

// Inside the mobile app (react-native-webview exposes window.ReactNativeWebView before page scripts run):
// lets CSS drop space reserved for web-only chrome (see html.in-app in index.css).
if (typeof window !== "undefined" && window.ReactNativeWebView) {
  document.documentElement.classList.add("in-app");
  // Map links open the phone's map app rather than Google's web map — see lib/utils.js.
  installMapLinkInterceptor();
  // tel:/mailto:/webcal: taps go to the shell on Android — see lib/externalLinks.js.
  installExternalLinkInterceptor();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
